import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'

export const ViewAllButton = () => {
  const {t} = useTranslation()

  return (
    <div className='d-flex justify-content-center border-top mt-4 pt-4'>
      <Link to='/notifications'>{t('NotificationTopbar.ViewAllButton.text')}</Link>
    </div>
  )
}
